import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

const fmt = (ts) => { try { return new Date(ts).toLocaleString('it-IT'); } catch (e) { return ts || '—'; } };

/* Il bollino dell'esito. «Bloccato» va tenuto distinto da «Fallito»: il primo e' il freno
   ai tentativi che ha chiuso la porta per dieci minuti, il secondo e' una password
   sbagliata. Confonderli vorrebbe dire non capire piu' niente il giorno in cui qualcuno
   telefona dicendo che non riesce a entrare. */
export function badgeEsito(esito) {
  if (esito === 'ok') return { testo: 'OK', colore: '#16a34a' };
  if (esito === 'bloccato') return { testo: 'Bloccato', colore: '#b45309' };
  return { testo: 'Fallito', colore: '#b91c1c' };
}

export default function CronologiaAccessiCard() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    setBusy(true);
    axios.get(`${API}/auth/accessi`).then((r) => setItems(r.data?.items || [])).catch(() => {}).finally(() => setBusy(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="imp-card imp-card--wide">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>Cronologia accessi</h2>
        <button className="btn btn-secondary" disabled={busy} onClick={load}>{busy ? '…' : 'Aggiorna'}</button>
      </div>
      {items.length === 0 ? (
        <div style={{ color: '#94a3b8', fontSize: 13 }}>Nessun accesso registrato.</div>
      ) : (
        <div style={{ overflowX: 'auto', maxHeight: 420, overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b' }}>
                <th style={{ padding: '6px 8px' }}>Esito</th>
                <th style={{ padding: '6px 8px' }}>Utente</th>
                <th style={{ padding: '6px 8px' }}>Data/ora</th>
                <th style={{ padding: '6px 8px' }}>IP</th>
                <th style={{ padding: '6px 8px' }}>Device</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a, i) => {
                const b = badgeEsito(a.esito);
                return (
                <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '6px 8px' }}>
                    <span style={{ fontSize: 11, fontWeight: 800, padding: '2px 8px', borderRadius: 10,
                      color: b.colore, background: `${b.colore}1f` }}>
                      {b.testo}
                    </span>
                  </td>
                  <td style={{ padding: '6px 8px', fontWeight: 600 }}>{a.username}</td>
                  <td style={{ padding: '6px 8px', color: '#475569' }}>{fmt(a.ts)}</td>
                  <td style={{ padding: '6px 8px', fontFamily: 'monospace' }}>{a.ip}</td>
                  <td style={{ padding: '6px 8px' }} title={a.user_agent}>{a.device}</td>
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
